<template>
  <div class="row equal">

    <div class="leftside col-md-7">
      <div class="col-md-offset-4 col-md-8">

        <checkout-breadcrumb/>

        <div v-if="guest" style="margin-top: 15px;margin-bottom: 15px">
          <span v-html="__t('shop.checkout.if_you_have_an_account_log_in_here',{
            here: `<a class='signin no-auth' href='#'>${ __t('shop.checkout.link_here_text')}</a>`
          })">

          </span><br>
          <span>
            {{ __t('shop.checkout.or_fill_the_following_form') }}
          </span><br>
        </div>



        <!-- PERSONAL -->
        <personal-info-form
            :fullname.sync="checkoutInfo.fullname"
            :mobile.sync="checkoutInfo.mobile"
            :email.sync="checkoutInfo.email"
            :country-code.sync="checkoutInfo.countryCode"
            :errors="errors"
            @clear-errors="clearErrors"
            @update:countryCode="updateCountryCode"
        />

        <div style="margin-top:15px; margin-bottom:15px" v-if="guest">
        <span v-html="__t('shop.checkout.for_faster_checkout_signup_here',{
          here:`<a class='signup no-auth' href='#'>${__t('shop.checkout.link_here_text')}</a>`
        })"><br>
        </span>
        </div>



        <div class="hidden-xs">
          <actionButtons
              @submit="submit"
              @back="backToShopping"
          />
        </div>

      </div>
    </div>
    <div class="rightside col-md-5">
      <div class="cart-container col-md-8">

        <div style="margin-bottom: 32px;display: flex;justify-content:flex-start;align-items: center">
          <i style="color:#1ABA75" class="fal fa-3x fa-bags-shopping"></i>
          <p style="margin-left: 24px">{{ __t('shop.cart.your_cart_has_x_products',{x: $_.sumBy(cart.items,(i) => Number(i.quantity)) }) }}</p>
        </div>

        <!-- COMPLETE ORDER -->
        <cart-table :cart="cart" :total-items-cost="cart.cart_after_discount_cost" :total-discount="cart.total_discount"
          :default-vat = "defaultVat"
          :b2b-enabled="b2bEnabled" @remove="couponRemoved" @vat-total="updateVatTotal"
          :company-alias="this.alias"
        />

        <!-- COUPON -->
        <div class="row padd30t">
          <div class="col-md-12">
            <div v-if="minimumPurchaseAmountEnabled && minimumPurchaseAmount > 0">
            {{ __('webapp.minimum_purchase_amount') }}: {{ minimumPurchaseAmount.toFixed(2) }}€
          </div>

            <div class="input-group">

              <label class="sr-only" for="coupon-code-input">Coupon</label>
              <input v-model="coupon_code" id="coupon-code-input" type="text" class="form-control"
                     :placeholder="__t('shop.checkout.coupon_code')">
              <span class="input-group-btn">
                  <button
                      @click.prevent="getDataAndApplyCoupon(coupon_code)"
                      class="btn shop-button apply-coupon-button"
                  >
                  {{ __t('shop.checkout.apply_coupon_code') }}
                  </button>
                </span>
            </div>
          </div>
        </div>


        <div class="text-right">
          <div v-if="cart.shipping_method_cost > 0">
            {{ cart.shipping_method_name }}: {{ cart.shipping_method_cost }} {{ currency }}
          </div>
          <div v-if="cart.payment_method_cost > 0">
            {{ cart.payment_method_name }}: {{ cart.payment_method_cost }} {{ currency }}
          </div>
           <div >
            <hr class="col-md-6 col-md-offset-5 " style="margin-top:30px;margin-bottom:5px" />
            <div class="cart-order-total">{{ __('webapp.order_total') }}: {{ totalCost}} {{ currency }}</div>
            <div  class="cart-vat-included" > {{ __('webapp.taxes_included') }} </div>
          </div>
        </div>

        <div class="padd30t visible-xs">
          <actionButtons @submit="submit"/>
        </div>

      </div>
      </div>
    </div>
</template>
<script>

import actionButtons from './eshop-checkout-personal-action-buttons';
import checkoutBreadcrumb from './eshop-checkout-breadcumb';
import PersonalInfoForm from './personal-info-form';
import CartTable from './common/cart-table'
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';

export default {
  components: {PersonalInfoForm, CartTable,actionButtons,checkoutBreadcrumb},
  data: function () {
    return {
      currency: window.currency,
      alias: window.company_alias,
      errors: [],
      coupon_code: null,
      authUserId : window.authUserId,
      activeCouponEmail : '',
      vatTotal: 0,
    }
  },
  props: {
      minimumPurchaseAmountEnabled: {
        type: Boolean,
        required: true
      },
      minimumPurchaseAmount: {
        type: Number,
        required: true
      },
      defaultVat: {
        type: Object,
        default: null
      },
      b2bEnabled: {
        type: String,
        required: true
      },
  },
  computed: {
    ...mapGetters({cart: 'getCart'}),
    ...mapGetters({shopInfo: 'getShopInfo'}),
    ...mapGetters({checkoutInfo: 'getCheckoutInfo'}),
    ...mapGetters(['cartTotalCost']),
    loggedIn(){
      return this.authUserId != "";
    },
    guest(){
      return !this.loggedIn;
    },
    hasErrors() {
      return !this.$_.isEmpty(this.errors)
    },
    totalCost() {
      var cost = Number(this.cart.total_cost);
      if (!this.b2bEnabled) {
        cost += parseFloat(this.vatTotal);
      }
      return cost.toFixed(2);

    },
  },
  methods: {
    ...mapActions([
      'initCart',
      'fetchShopInfo',
      'fetchCheckoutInfo',
      'applyCoupon',
      'removeCoupon'
    ]),
    clearErrors() {
      this.errors = []
    },
    showValidationErrors(errors) {
      this.$_.forEach(errors, messages => {
        this.$_.forEach(messages, message => {
          toastr.error(message);
        });
      });
    },
    backToShopping(){
      window.location.href = this.shopInfo.shopUrl;
    },
    getDataAndApplyCoupon(coupon){
      let customerEmail = $('#personal-info-email')[0].value;

      if (!customerEmail) {
        alert(__('companyadmin.fill_personal_info_first'));
        return;
      }
  
      this.applyCoupon({ couponCode: coupon, customerEmail })
        .then((success) => {
            if (success) {
                this.activeCouponEmail = customerEmail;
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    couponRemoved(){
      this.activeCouponEmail = '';
    },
    updateVatTotal(vatTotal) {
      this.vatTotal = vatTotal;
    },   
    submit() {
      var self = this;
      var data = {
        locale: window.language,
        fullname: this.checkoutInfo.fullname,
        mobile: this.checkoutInfo.mobile,
        email: this.checkoutInfo.email,
        countryCode: this.checkoutInfo.countryCode,
      };

      if(this.activeCouponEmail != '' && this.activeCouponEmail != this.checkoutInfo.email){
        alert(__('companyadmin.coupon_email_different_from_checkout'));
        return ;
      }

      $.ajax({
        type: 'POST',
        url: route('webapp.ordering.checkout.submit.personal', this.alias),
        data: data,
        success(response) {
          if (response.hasOwnProperty('redirect')) {
            window.location.href = response.redirect;
          }

        },
        error(error) {
          if (error.responseJSON && error.responseJSON.error) {
            toastr.error(error.responseJSON.error);
          }

          self.errors = error.responseJSON.errors || {};
          self.showValidationErrors(self.errors);
        }
      });
    },
    updateCountryCode(code) {
      this.countryCode = code;
    }
  },
  created() {
    this.initCart(this.alias);
    this.fetchShopInfo();
    this.fetchCheckoutInfo();
  }
}
</script>

<style>
  .cart-order-total {
    font-weight:bold ;
    font-size: 21px;

  }

</style>
